import { render, staticRenderFns } from "./ProductAttributeItem.vue?vue&type=template&id=5894db6a&lang=pug&"
import script from "./ProductAttributeItem.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports